
// @ts-nocheck
import { Options, Vue } from 'vue-class-component';
import { nextTick, onMounted, onUnmounted, ref } from 'vue';

@Options({
    components: {}
})
export default class App extends Vue {
    mounted() {}
    unmounted() {}
}
